import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { SendLetterQueryParams, SendLetterResponseDTO } from "./models";

export class SendLetterApi {
  static sendLetter = async (params: SendLetterQueryParams) => {
    const response = GbApiRequestService.post(
      "userRpc",
      new URLSearchParams({
        type: JSON.stringify({
          dataMap: {
            doSend: true,
            letter: {
              direction: "MAN_TO_LADY",
              ...params,
            },
          },
          processorClass: "SaveLetter",
        }),
      }),
    );

    return await withSchemaValidation(response, SendLetterResponseDTO);
  };
}
